import { render, staticRenderFns } from "./show-more.vue?vue&type=template&id=5ebec418&scoped=true&"
import script from "./show-more.vue?vue&type=script&lang=js&"
export * from "./show-more.vue?vue&type=script&lang=js&"
import style0 from "./show-more.vue?vue&type=style&index=0&id=5ebec418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebec418",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ebec418')) {
      api.createRecord('5ebec418', component.options)
    } else {
      api.reload('5ebec418', component.options)
    }
    module.hot.accept("./show-more.vue?vue&type=template&id=5ebec418&scoped=true&", function () {
      api.rerender('5ebec418', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/elements/show-more.vue"
export default component.exports